import React from 'react';
import { EmptyStateSVG } from '@components/Landing/FeaturedStatus/EmptyStateSVG';
import { MintedByTopCollectors } from '@components/Landing/sections/MintedByTopCollectors';
import { Button } from '@components/main-components/button/Button';
import { NAV_LINKS } from '@utils/constants';

export const UpcomingRecentEmptyState = ({ type }: { type: 'upcoming' | 'recent' }) => {
  return (
    <div className="flex w-full flex-col gap-5">
      <div className="flex h-auto w-full flex-col items-center justify-center rounded-md bg-base50 px-4 py-16 text-center md:h-[350px]">
        <div className="hidden sm:block">
          <EmptyStateSVG />
        </div>
        <span className="mt-4 font-title text-title-m font-medium text-base900">
          It's quiet in here
        </span>
        {type === 'recent' ? (
          <span className="mb-6 mt-2 font-base text-base-m text-base600">
            We currently do not have <br className="hidden md:block" />
            any recent drops
          </span>
        ) : (
          <span className="mb-6 mt-2 font-base text-base-m text-base600">
            Your followed artists don't have any upcoming drops.
          </span>
        )}
        <Button size="M" variant="primary" label="Search for a drop" href={NAV_LINKS.Search} />
      </div>

      <MintedByTopCollectors />
    </div>
  );
};
